export default "__VITE_ASSET__D9Hvdfn3__"